import React, { useState, useEffect } from 'react';
import './categories.css';
import Beard from '../../assets/images/logo-beard2.svg';
import EmptyCard from '../../assets/images/empty-card.svg';
import Filter from '../../assets/icons/filter.svg';
import Search from '../../assets/icons/search.svg';
import { InputSwitch } from 'primereact/inputswitch';
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Paginator } from 'primereact/paginator';
import Footer from '../../layout/footer/footer';
import { useLocation } from "react-router-dom";
import { getProductsBySearch, imgBaseUrl } from '../../utils/api';
import { Sidebar } from 'primereact/sidebar';
import { Skeleton } from 'primereact/skeleton';
import debounce from 'lodash.debounce'; // نصب با npm i lodash.debounce
import Loader from '../../components/loader/dotloader'


function Categories() {
    const [categoryChecked, setCategoryChecked] = useState([]);  // Holds array of selected category IDs
    const [categoryId, setCategoryId] = useState([]);  // Holds array of selected category IDs
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(9);
    const [total, setTotal] = useState(0);  // Adjust total dynamically
    const [categoryList, setCategoryList] = useState([]);
    const [products, setProducts] = useState([]);
    const [categoryTitle, setCategoryTitle] = useState('');
    const [search, setSearch] = useState('');
    const [breadTitle, setBreadTitle] = useState('');
    const [visibleFilter, setVisibleFilter] = useState(false);
    const [visibleCategory, setVisibleCategory] = useState(false);
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const [breadcrumbItems, setBreadcrumbItems] = useState([
        { label: 'کادونا' },
        { label: 'دسته بندی ها' }
    ]);

    // Fetch products for the selected category and append to the list
    const fetchProducts = async (categoryId, categoryTitle, newPage = 0, categoryIds) => {
        const pay = {
            pageNumber: newPage,
            pageSize: rows,
            categoryIds: categoryIds?.length > 0 ? categoryIds.join(',') : '',
            categoryId: categoryId && categoryId !== 0 ? categoryId : 0,
            productTitle: categoryTitle || "",
        };

        try {
            setLoading(true); // نمایش حالت لودینگ
            const res = await getProductsBySearch(pay);
            const fetchedItems = res.data.data.items;
            const newTotal = res.data.data.total;

            setProducts(fetchedItems);
            setTotal(newTotal);
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setLoading(false);
        }
    };

    // Initial load and URL-based fetch on mount
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const Id = queryParams.get("id");
        const Title = queryParams.get("title");
        setCategoryId(Id || '');  // Set initial selected category if present in URL
        // setBreadTitle(Title || '');

        const cat = JSON.parse(sessionStorage.getItem('categories'));
        setCategoryList(cat);

        let initialCategory = cat.find(category => category.id === parseInt(Id));

        // Fetch initial category products if there's an initial category selected from URL
        if(Id == '-1')
        {
           fetchProducts(-1, '', 0)  
        }
        else if (Id && !!initialCategory) {
            // fetchProducts(Id, Title, 0);
            handleCategoryChange(initialCategory, true);
        }
        else {
            fetchProducts(0, '', 0)
        }

    }, [location.search]);

    // Fetch products when category filter changes
    // useEffect(() => {
    //     if (categoryChecked) {
    //         // Clear current products and fetch new ones only for the newly selected category
    //         setProducts([]);
    //         setTotal(0);
    //         fetchProducts(categoryChecked);
    //     }
    // }, [categoryChecked, categoryTitle]);
    useEffect(() => {
        setBreadcrumbItems([
            { label: 'کادونا' },
            { label: 'دسته بندی ها' },
            { label: breadTitle || 'همه محصولات' }
        ]);
    }, [breadTitle]);

    // Handle page change
    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        // محاسبه شماره صفحه جدید و دریافت محصولات
        const newPage = Math.floor(event.first / event.rows) + 1;
        if (categoryChecked.length > 0) {

            fetchProducts(0, search, newPage, categoryChecked);
        } else {
            fetchProducts(categoryId, search, newPage, '');

        }
    };

    // Update selected category and fetch its products
    const handleCategoryChange = (item, isInitial = false) => {
        if (isInitial === true) {
            fetchProducts(0, '', 0, [item.id]); // executed when called from url-location-change (select from navbar)
            setCategoryChecked([item.id]);
            return;
        }
        // اگر دسته‌بندی قبلاً انتخاب شده باشد، آن را از آرایه حذف کنید.
        if (categoryChecked.includes(item.id)) {
            let data = categoryChecked.filter(id => id !== item.id)
            setCategoryChecked(data);
            fetchProducts(0, search, 0, data); // صفحه اول را برای بارگذاری مجدد بخواهید

        } else {
            // در غیر این صورت، دسته‌بندی را به آرایه اضافه کنید.
            let data = [...categoryChecked, item.id]
            setCategoryChecked(data);
            fetchProducts(0, search, 0, data); // صفحه اول را برای بارگذاری مجدد بخواهید

        }

        // بازنشانی محصولات و تعداد به ۰ برای بارگذاری مجدد با دسته‌بندی‌های جدید
        setProducts([]);
        setTotal(0);
        // fetchProducts(0, '', 0,categoryChecked); // صفحه اول را برای بارگذاری مجدد بخواهید
    };

    // Select all and deselect all categories
    const handleCategoryChangeBulk = (e) => {
        let selectAll = e.target.checked;
        if (selectAll === true) {
            let data = ([...categoryList].map(item => item.id));
            setCategoryChecked(data);
            fetchProducts(0, search, 0, data); // صفحه اول را برای بارگذاری مجدد بخواهید

        } else {
            let data = [];
            setCategoryChecked(data);
            fetchProducts(0, search, 0, data); // صفحه اول را برای بارگذاری مجدد بخواهید
        }

        // بازنشانی محصولات و تعداد به ۰ برای بارگذاری مجدد با دسته‌بندی‌های جدید
        setProducts([]);
        setTotal(0);
        // fetchProducts(0, '', 0,categoryChecked); // صفحه اول را برای بارگذاری مجدد بخواهید
    };
    useEffect(() => {
        if (categoryChecked.length > 0) {
            let names = '';
            categoryList.filter(category => categoryChecked.includes(category.id)).map((category, index) => {
                if (index === 4) {
                    names += '...';
                    return;
                }
                if (index >= 5) {
                    return;
                }
                names += category.text;
                if (index + 1 !== categoryChecked.length) {
                    names += ', '
                }
            })
            setBreadTitle(names);
        }
        else {
            setBreadTitle(null);
        }
    }, [categoryChecked])




    // تابع جستجو
    const searchProduct = (query) => {
        // if (query.trim().length > 0) {
        fetchProducts("", search, 0, categoryChecked);
        // }
    };

    // تابع debounced که جستجو را در ضریبی از 4 کاراکتر انجام می‌دهد
    useEffect(() => {

        return () => {

        }
    }, [])

    const handleSearchInput = debounce((query) => {
        if (query.length % 4 === 0 && query.length > 0) {
            searchProduct(query); // جستجو را فراخوانی می‌کنیم
        }
    }, 500); // تاخیر 500 میلی‌ثانیه

    // تغییرات در جعبه جستجو
    const onSearchTextChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        handleSearchInput(value); // ارسال به debounced
    };
    // setTimeout(() => {
    // const items = [{ label: 'کادونا' }, { label: 'دسته بندی ها' }, { label: categoryTitle }];

    // }, 1000);
    function convertToPersianNumbers(input) {
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        return input.replace(/\d/g, (digit) => persianDigits[digit]);
      }
    return (
        <>
            {loading && <Loader isLoading={loading} />}
            <div className='container'>
                <div className='d-flex align-items-center title gap-3 '><img src={Beard} alt="" />دسته بندی ها</div>
                <div className='d-flex align-items-start gap-2 flex-col-dir cat-body'>
                    <div className='filter-card web-filter'>
                        <div className='title'>
                            <img src={Filter} alt="" />
                            فیلتر ها
                        </div>
                        <div className='mt-5'>
                            <Form action='#'>
                                {/* <Form.Check type="switch" id="custom-switch" label="نمایش کالاهای موجود" />
                                <Form.Check type="switch" id="custom-switch" className='mt-3' label="نمایش کالاهای تخفیف‌دار" /> */}
                                <Form.Group controlId="text" className='mt-4'>
                                    <Form.Label style={{ fontWeight: '600' }}>جستجو</Form.Label>
                                    <div className='d-flex align-items-center input-icon'>
                                        <Form.Control
                                            value={search}
                                            onChange={onSearchTextChange}
                                            onKeyUp={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    searchProduct(e.target.value);
                                                }
                                            }}
                                        />
                                        <button className='btn  text-center' type='submit'> <img src={Search} alt="Search" /></button>
                                    </div>
                                </Form.Group>
                            </Form>
                            <Accordion activeIndex={0} className='mt-4'>
                                <AccordionTab header="دسته بندی ها">
                                    <Form className='filter-category'>
                                        <Form.Check
                                            onChange={handleCategoryChangeBulk}
                                            type='checkbox'
                                            label="همه محصولات"
                                            id="select-all-categories"
                                        />
                                        {categoryList.map((item) => (
                                            <Form.Check
                                                key={item.id}
                                                onChange={() => handleCategoryChange(item)}
                                                type='checkbox'
                                                label={item.text}
                                                id={item.id}
                                                checked={categoryChecked.includes(item.id)} // بررسی چندگانه بودن

                                            />
                                        ))}
                                    </Form>
                                </AccordionTab>
                            </Accordion>
                        </div>
                    </div>
                    <BreadCrumb className='mobile' model={breadcrumbItems} />
                    <div className='mobile-filter'>
                        <div className='item' onClick={() => setVisibleFilter(true)}>
                            <img src={Filter} alt="" />
                        </div>
                        <div className='flex-1'>
                            <Form action='#'>
                                <Form.Group controlId="text">
                                    <div className='input-icon' >
                                        <Form.Control placeholder='جستجو' style={{height: '33px'}} value={search} onChange={(e) => setSearch(e.target.value)} onKeyUp={(e) => {
                                            if (e.key === 'Enter') {
                                                console.log("PREVENT ");

                                                e.preventDefault();
                                                searchProduct(e);
                                            }
                                        }} />
                                        <img src={Search} alt="" />
                                    </div>
                                </Form.Group>
                            </Form>
                        </div>
                        <div >
                            <button className='btn btn-outline-secondry text-xs' style={{ textWrap: 'nowrap' }} onClick={(e) => setVisibleCategory(true)}>دسته بندی ها</button>
                        </div>
                        <Sidebar header="دسته بندی ها" visible={visibleCategory} position="bottom" onHide={() => setVisibleCategory(false)}>
                            <Form className='filter-category px-2'>
                                {categoryList.length && categoryList.map((item) => (

                                    <Form.Check
                                        key={item.id}
                                        onChange={() => handleCategoryChange(item)}
                                        type='checkbox'
                                        label={item.text}
                                        id={item.id}
                                        checked={categoryChecked.includes(item.id)} // بررسی چندگانه بودن

                                    />
                                ))}
                            </Form>
                            <div style={{ position: 'absolute', bottom: '1em', left: '0', zIndex: '1000' }} className='px-3 gap-2 w-100 d-flex align-items-center justify-content-between'>
                                <button className='btn btn-primary flex-1' onClick={(e) => setVisibleCategory(false)}>مشاهده</button>
                                <button className='btn btn-outline-primary flex-1' onClick={(e) => setCategoryChecked('')}>حذف فیلتر</button>
                            </div>
                        </Sidebar>
                    </div>
                    <div className='w-100' style={{ overflow: 'hidden' }}>
                        <BreadCrumb className='web' model={breadcrumbItems} />
                        <div className='row cat-items gx-3 gy-3'>
                            {loading ? (
                                Array.from({ length: rows }).map((_, index) => (
                                    <div className='col-6 col-md-6 col-lg-4' key={index}>
                                        <div className='item'>
                                            <div className='img-box'>
                                                <Skeleton shape="rectangle" height="200px" />
                                            </div>
                                            <Skeleton width="70%" className='mt-3' />
                                            <Skeleton width="50%" className='mt-2' />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                products.map((product, index) => (
                                    <div className='col-6 col-md-6 col-lg-4' key={index}>
                                        <div className='item' onClick={() => {
                                            window.location.href = `/productDetail?productId=${product.id}`;
                                        }}>

                                            <div className='img-box'>
                                                <img
                                                    className={`rounded-2xl ${loaded ? 'img-loaded' : 'img-blur-placeholder'}`}
                                                    src={loaded ? (product.imageUrl ? imgBaseUrl + product.imageUrl : EmptyCard) : EmptyCard} // تصویر نمایش داده‌شده
                                                    alt={product.title || 'Loading placeholder'}
                                                    onLoad={() => setLoaded(true)} // وقتی تصویر اصلی لود شد
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = EmptyCard; // در صورت خطا، تصویر جایگزین نمایش داده شود
                                                    }}
                                                />

                                            </div>
                                            <h6 className='text-right mt-3 font-bold text-sm' style={{minHeight: '40px'}}>{convertToPersianNumbers(product.title)}</h6>
                                            <div className='card-price mt-3'>
                                             {product.price2 > 0 ? (
                                                <>
                                                <span className="strikethrough-diagonal text-dark text-lg number font-bold p-2 opacity-60">
                                                    {parseInt(product.price).toLocaleString()} 
                                                </span>
                                                <span className='number color-primary text-xl font-semibold'>{parseInt(product.price2).toLocaleString()} تومان</span>
                                                </>
                                            ) : (
                                                <h5 className='number color-primary text-xl font-semibold'>{parseInt(product.price).toLocaleString()} تومان</h5>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={total} onPageChange={onPageChange} />
                    </div>
                </div>
            </div>
            <div className="home-footer mt-40">
                <Footer />
            </div>
        </>
    );
}

export default Categories;
